// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.menu-panel {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 100%;
  margin: 0 auto 40px;
  position: relative;
  gap: 10px 32px;
}
.menu-panel:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: -50%;
  width: 200%;
  height: 1px;
  background: rgb(235, 238, 245);
  z-index: 1;
}
@media screen and (max-width: 1200px) {
  .menu-panel:after {
    bottom: -5px;
  }
}
.menu-panel .menu-item {
  font-weight: 600;
  font-size: 16px;
  flex: 0 0 auto;
  white-space: nowrap;
  text-align: center;
  text-transform: uppercase;
  caret-color: transparent;
  color: rgb(75, 76, 80);
  opacity: 0.6;
  padding: 0 10px;
  text-decoration: none;
}
@media screen and (max-width: 1200px) {
  .menu-panel .menu-item {
    font-size: 13px;
  }
}
.menu-panel .menu-item.available {
  opacity: 1;
}
.menu-panel .menu-item.available:hover {
  cursor: pointer;
}
.menu-panel .menu-item.available.disabled {
  opacity: 0.6;
  pointer-events: none !important;
}
.menu-panel .menu-item.disabled {
  cursor: auto;
}
.menu-panel .menu-item.active {
  color: #f90047;
  opacity: 1;
  position: relative;
}
.menu-panel .menu-item.active:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  left: 0;
  bottom: -10px;
  background-color: #f90047;
  z-index: 5;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
